import { common } from './common';
import { projects } from './projects';
import { experience } from './experience';
import { footer } from './footer';
import { privacy } from './privacy';
import { terms } from './terms';
import { cookies } from './cookies';
import { chat as chatEn } from './en/chat';
import { chat as chatIt } from './it/chat';
import { testimonials } from './testimonials';
import { contact } from './contact';
import { navigation } from './navigation';
import { aboutTranslation } from './about';
import { solutions } from './solutions';
import { services } from './services';

// Helper function to flatten nested objects with array support
const flattenObject = (obj: any, prefix = ''): Record<string, any> => {
  return Object.keys(obj).reduce((acc: Record<string, any>, k: string) => {
    const pre = prefix.length ? prefix + '.' : '';
    
    if (
      typeof obj[k] === 'object' && 
      obj[k] !== null && 
      !Array.isArray(obj[k])
    ) {
      Object.assign(acc, flattenObject(obj[k], pre + k));
    } else {
      acc[pre + k] = obj[k];
    }
    
    return acc;
  }, {});
};

// Helper function to merge translations
const mergeTranslations = (translations: Record<string, any>, prefix: string) => {
  const flattened = flattenObject(translations);
  return Object.keys(flattened).reduce((acc: Record<string, any>, key: string) => {
    acc[`${prefix}.${key}`] = flattened[key];
    return acc;
  }, {});
};

export const resources = {
  it: {
    translation: {
      ...common.it,
      ...mergeTranslations(projects.it, 'projects'),
      ...mergeTranslations(experience.it, 'experience'),
      ...mergeTranslations(footer.it, 'footer'),
      ...mergeTranslations(privacy.it, 'privacy'),
      ...mergeTranslations(terms.it, 'terms'),
      ...mergeTranslations(cookies.it, 'cookies'),
      ...mergeTranslations(chatIt, 'chat'),
      ...mergeTranslations(testimonials.it, 'testimonials'),
      ...mergeTranslations(contact.it, 'contact'),
      ...mergeTranslations(navigation.it, 'navigation'),
      ...mergeTranslations(aboutTranslation.it, 'about'),
      ...mergeTranslations(solutions.it, 'solutions'),
      ...mergeTranslations(services.it, 'services')
    }
  },
  en: {
    translation: {
      ...common.en,
      ...mergeTranslations(projects.en, 'projects'),
      ...mergeTranslations(experience.en, 'experience'),
      ...mergeTranslations(footer.en, 'footer'),
      ...mergeTranslations(privacy.en, 'privacy'),
      ...mergeTranslations(terms.en, 'terms'),
      ...mergeTranslations(cookies.en, 'cookies'),
      ...mergeTranslations(chatEn, 'chat'),
      ...mergeTranslations(testimonials.en, 'testimonials'),
      ...mergeTranslations(contact.en, 'contact'),
      ...mergeTranslations(navigation.en, 'navigation'),
      ...mergeTranslations(aboutTranslation.en, 'about'),
      ...mergeTranslations(solutions.en, 'solutions'),
      ...mergeTranslations(services.en, 'services')
    }
  }
};